<div mat-dialog-title fxLayout fxLayoutAlign="space-between center">
    @if (isPreset) {
        <h5 class="cipo--text--ellipsed" data-testid="transition-dialog-title">
            {{ "general.add" | translate }} {{ currentModule?.name }}
        </h5>
    } @else {
        <h5 class="cipo--text--ellipsed" data-testid="transition-dialog-title">
            {{ currentModule?.name }} {{ fullDocNumbers() }}
        </h5>
    }
    <div fxLayout fxLayoutAlign="end center">
        <h5 class="m-r" data-testid="transition-dialog-transition-name">{{ data.transition.name }}</h5>
        <button
            mat-icon-button
            (click)="fullscreen.toggleFullscreen()"
            [attr.aria-label]="
                (fullscreen.isFullscreen() ? 'a11y.dialog.fullscreenExit' : 'a11y.dialog.fullscreenEnter') | translate
            "
            data-testid="transition-dialog-fullscreen-button">
            <mat-icon class="material-symbols-outlined" aria-hidden="true">
                {{ fullscreen.isFullscreen() ? "fullscreen_exit" : "fullscreen" }}
            </mat-icon>
        </button>
        <button mat-icon-button mat-dialog-close [aria-label]="'a11y.dialog.close' | translate">
            <mat-icon aria-hidden="true">close</mat-icon>
        </button>
    </div>
</div>
<mat-dialog-content>
    <cipo-document-header [data]="headerData()" />
    <div class="cipo--border-bottom--lite m-y"></div>

    @if (data.signatureIsRequired) {
        <div class="p-b m-b cipo--border-bottom--lite" data-testid="transition-dialog-signature-section">
            <div class="cipo-bg--warn-100 cipo-text--medium-lg cipo--text--center">
                {{ "signature.signatureRequired" | translate }}
            </div>
            <cipo-signature (currentSignatureChange)="signatureSet()" />
        </div>
    }

    <cipo-dynamic-form
        #dynamicForm
        [contractId]="docProps.contractId"
        [readonly]="false"
        [fields]="gridFields()?.fields"
        [form]="form"
        (formValuesPrepared)="submit($event)" />

    @if (showNotificationForm()) {
        <div class="m-t">
            <cipo-notification-form
                [data]="notificationData()"
                [disabled]="submitting()"
                (valueChanged)="onNotificationValueChanged($event)" />
        </div>
    }
</mat-dialog-content>
<mat-dialog-actions>
    <div class="cipo--width--full">
        @if (actionsData()) {
            <cipo-document-actions
                [data]="actionsData()"
                (close)="dialogRef.close([])"
                (assignmentChanged)="onAssignmentChanged($event)"
                (submitRequested)="requestSubmit()" />
        }
    </div>
</mat-dialog-actions>
